/**
 * Focus Ring Tokens
 * Accessible focus indicators (WCAG 2.2)
 */

export const baseFocus = {
  ring: {
    width: 2,
    offset: 2,
    style: 'solid'
  }
} as const;
